// src/features/lockers/components/ui/LockerStatusChip.tsx
import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  CheckCircle,
  Lock,
  Build,
  Cancel,
  Schedule,
  Block,
} from '@mui/icons-material';
import { LockerStatus, getLockerStatusColor, getLockerStatusLabel } from '../../types';

export interface LockerStatusChipProps {
  status: LockerStatus;
  variant?: ChipProps['variant'];
  showIcon?: boolean;
}

export const LockerStatusChip: React.FC<LockerStatusChipProps> = ({
  status,
  variant = 'filled',
  showIcon = true,
}) => {
  const getIcon = () => {
    if (!showIcon) return undefined;
    
    switch (status) {
      case LockerStatus.Available:
        return <CheckCircle sx={{ fontSize: 16 }} />;
      case LockerStatus.Occupied:
        return <Lock sx={{ fontSize: 16 }} />;
      case LockerStatus.Reserved:
        return <Schedule sx={{ fontSize: 16 }} />;
      case LockerStatus.Blocked:
        return <Block sx={{ fontSize: 16 }} />;
      default:
        return undefined;
    }
  };

  return (
    <Chip
      icon={getIcon()}
      label={getLockerStatusLabel(status)}
      color={getLockerStatusColor(status)}
      variant={variant}
      size="small"
      sx={{
        fontWeight: 500,
        '& .MuiChip-icon': {
          ml: 0.5,
        },
      }}
    />
  );
};

export default LockerStatusChip;